import { render, staticRenderFns } from "./ActivitysidemenuNew.vue?vue&type=template&id=279c9aaa&scoped=true"
import script from "./ActivitysidemenuNew.vue?vue&type=script&lang=js"
export * from "./ActivitysidemenuNew.vue?vue&type=script&lang=js"
import style0 from "./ActivitysidemenuNew.vue?vue&type=style&index=0&id=279c9aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279c9aaa",
  null
  
)

export default component.exports